import Screen from "@/src/components/Screen/Screen";
import { textVariants } from "@/src/components/Text/Text";
import { useTheme } from "@/src/context/themeContext";
import ShieldCheckIcon from "@/src/svg/ShieldCheck";
import ShieldIcon from "@/src/svg/shield";
import UserIcon from "@/src/svg/user";
import clsx from "clsx";
import { useTranslation } from "react-i18next";
import { NavLink, Outlet, useLocation } from "react-router-dom";

const Settings = () => {
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.settings.${key}`);
  const { pathname } = useLocation();
  const { theme } = useTheme();

  const navLinks = [
    {
      name: trans("tabs.profile"),
      route: "profile",
      icon: UserIcon,
    },
    {
      name: trans("tabs.securityCenter"),
      route: "security-center",
      icon: ShieldIcon,
    },
    {
      name: trans("tabs.verifications"),
      route: "verifications",
      icon: ShieldCheckIcon,
    },
    {
      name: trans("tabs.notifications"),
      route: "notifications",
      icon: UserIcon,
    },
  ];

  return (
    <Screen>
      <div className="grid md:grid-cols-4 gap-5 ">
        <div className="flex col-span-4 md:hidden space-x-4 w-full  overflow-x-scroll">
          {navLinks?.map((item) => (
            <NavLink
              key={item?.name}
              className={({ isActive }) =>
                clsx(
                  isActive &&
                    "border-b-2 border-indigo dark:border-grey-300 text-indigo dark:text-grey-200",
                  textVariants(),
                  " text-sm text-gray-700 md:pb-1 whitespace-nowrap flex font-semibold "
                )
              }
              to={item?.route}
            >
              <span className=" dark:hover:bg-grey-500 p-2  rounded-md">
                {item?.name}
              </span>
            </NavLink>
          ))}
        </div>
        <div className="md:col-span-1 col-span-4 ">
          <div className="p-2 md:grid hidden gap-3 text-gray-600 sticky top-20">
            {navLinks.map((item, idx) => (
              <NavLink
                key={idx}
                className={({ isActive }) =>
                  clsx(
                    isActive &&
                      "bg-[#E7EDF7] dark:bg-grey-400 dark:text-white  text-[#2F60E0] font-semibold",
                    // textVariants(),
                    "hover:bg-indigo-200 dark:hover:text-white dark:text-gray-400 dark:hover:bg-grey-200 p-2 rounded"
                  )
                }
                to={item?.route}
              >
                <div className="flex items-center gap-2">
                  <span>
                    <item.icon
                      height={24}
                      width={24}
                      color={
                        pathname.includes(item?.route)
                          ? theme !== "light"
                            ? "white"
                            : "#2F60E0"
                          : undefined
                      }
                    />
                  </span>
                  {item?.name}
                </div>
              </NavLink>
            ))}
          </div>
        </div>
        <div className="md:col-span-3 col-span-4 min-h-[80vh] overflow-y-scroll">
          <Outlet />
        </div>
      </div>
    </Screen>
  );
};

export default Settings;
